import { Box, Button, Card, CardContent, Stack, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useContext, useEffect } from "react";
import { externalNavigate } from "../helpers";
import headerImage from '../images/landing.webp';
import mobileHeaderImage from '../images/mobile_hero.webp';
import nahbLogo from '../images/logos/nahb_logo.png';
import fhbaLogo from '../images/logos/fhba_logo.png';
import tbbaLogo from '../images/logos/tbba_logo.jpg';
import ProjectTimeline from "./ProjectTimeline";
import ProjectTimelineMobile from "./ProjectTimeline2";
import Grid from '@mui/material/Unstable_Grid2';
import vanImage from '../images/van.webp';
import contactImage from '../images/contact-img.webp';
import EmailIcon from '@mui/icons-material/Email';
import PhoneIcon from '@mui/icons-material/Phone';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import InstagramIcon from '@mui/icons-material/Instagram';
import { ScrollContext } from "../App";
import TikTokIcon from "./TikTokIcon";

const orgLogos = [
    tbbaLogo,
    fhbaLogo,
    nahbLogo
]


export function Landing() {
    const navigate = useNavigate();
    const { setIsScrolled } = useContext(ScrollContext);

    useEffect(() => {
        const handleScroll = () => {
            setIsScrolled(window.scrollY);
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, [setIsScrolled]);

    return (

        <Box sx={{ display: "flex", flexWrap: 'wrap', flexDirection: 'column', overflow: 'hidden' }}>

            <Box sx={{ width: '100%', height: '100vh', backgroundSize: 'cover', backgroundPositionY: 'center', backgroundPositionX: 'center', backgroundImage: {xs: `url(${mobileHeaderImage})`, md: `url(${headerImage})` } , display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <Box sx={{ width: '100%', height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', textAlign: 'center', bgcolor: 'rgba(0, 0, 0, 0.4)', color: '#FFFFFF' }}>
                    <Box sx={{ p: 1 }}>
                        <Box sx={{ display: 'flex', flexDirection: { xs: 'column', md: 'row' }, gap: 1, alignItems: 'center', justifyContent: 'center' }}>
                            <Typography variant="h3">You dream it.</Typography>
                            <Typography variant="h3">We build it.</Typography>
                        </Box>
                        <Typography variant="h6">Furniture you will love.</Typography>
                        <Stack spacing={1} direction={{ xs: 'column', md: 'row' }} sx={{ justifyContent: 'center' }}>
                            <Button onClick={() => { navigate('/gallery') }} variant="outlined" size="large" sx={{ color: '#FFFFFF', borderColor: '#FFFFFF' }}>View our work</Button >
                            <Button onClick={() => { externalNavigate('tel:813-215-3262') }} variant="contained" disableElevation size="large" sx={{ color: '#FFFFFF', borderColor: '#FFFFFF', display: { xs: 'inline-flex', sm: 'inline-flex', md: 'none' } }}>Call Us </Button>
                        </Stack>
                    </Box>
                </Box>
            </Box>

            <Box sx={{ display: "flex", flexWrap: 'wrap', flexDirection: 'column', m: 0, px: { xs: 2, sm: 2, md: 1, lg: 20 } }}>

                {/* Section: Contact */}
                <Box sx={{ p: 4, mt: { xs: 15, sm: 15, md: 20, lg: 30 }, bgcolor: 'secondary.main', position: 'relative', minHeight: '700px', display: 'flex', alignItems: 'center' }}>
                    <Box sx={{ position: 'absolute', top: '-60px', left: '-60px', width: '60px', height: '60px', borderTop: '10px solid', borderColor: 'secondary.main', borderLeft: '10px solid', borderLeftColor: 'secondary.main' }} />
                    <Box sx={{ position: 'absolute', bottom: '-60px', right: '-60px', width: '60px', height: '60px', borderBottom: '10px solid', borderColor: 'secondary.main', borderRight: '10px solid', borderRightColor: 'secondary.main' }} />
                <Grid container rowSpacing={6} spacing={2} columns={12}>
                    <Grid id="contact-info" item xs={12} sm={12} md={5} lg={4} mdOffset={1} lgOffset={2} sx={{ textAlign: 'left', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}  >
                        <Typography variant="h4" sx={{ color: '#FFFFFF', mb: 2 }}>
                            Get in Touch
                        </Typography>
                        <Typography variant="body1" sx={{ color: '#FFFFFF', opacity: 0.9, mb: 4 }}>
                            Have a project in mind? We'd love to hear from you. Reach out today to discuss your vision.
                        </Typography>
                        <Stack spacing={3} sx={{ alignItems: 'left' }}>
                            <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 2 }}>
                                <EmailIcon sx={{ fontSize: 30, mt: 0.5, color: '#FFFFFF' }} />
                                <Box sx={{ color: '#FFFFFF' }}>
                                    <Typography variant="h6" sx={{ color: '#FFFFFF' }}>Email</Typography>
                                    <Typography variant="body2" sx={{ cursor: 'pointer', color: '#FFFFFF', '&:hover': { textDecoration: 'underline' } }} onClick={() => externalNavigate('mailto:ecvconstruction45@gmail.com')}>
                                        ecvconstruction45@gmail.com
                                    </Typography>
                                </Box>
                            </Box>
                            <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 2 }}>
                                <PhoneIcon sx={{ fontSize: 30, mt: 0.5, color: '#FFFFFF' }} />
                                <Box sx={{ color: '#FFFFFF' }}>
                                    <Typography variant="h6" sx={{ color: '#FFFFFF' }}>Phone</Typography>
                                    <Typography variant="body2" sx={{ cursor: 'pointer', color: '#FFFFFF', '&:hover': { textDecoration: 'underline' } }} onClick={() => externalNavigate('tel:813-215-3262')}>
                                        (813) 215-3262
                                    </Typography>
                                    <Typography variant="body2" sx={{ cursor: 'pointer', color: '#FFFFFF', '&:hover': { textDecoration: 'underline' } }} onClick={() => externalNavigate('tel:813-573-2131')}>
                                        (813) 573-2131
                                    </Typography>
                                </Box>
                            </Box>
                            <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 2 }}>
                                <LocationOnIcon sx={{ fontSize: 30, mt: 0.5, color: '#FFFFFF' }} />
                                <Box sx={{ color: '#FFFFFF' }}>
                                    <Typography variant="h6" sx={{ color: '#FFFFFF' }}>Address</Typography>
                                    <Typography variant="body2" sx={{ cursor: 'pointer', color: '#FFFFFF', '&:hover': { textDecoration: 'underline' } }} onClick={() => externalNavigate('https://www.google.com/maps?ll=28.022722,-82.541368&z=16&t=h&hl=en&gl=US&mapclient=embed&cid=5076629334269934077')}>
                                        8009 Benjamin Rd<br />Tampa, FL 33634
                                    </Typography>
                                </Box>
                            </Box>
                            <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 2 }}>
                                <InstagramIcon sx={{ fontSize: 30, mt: 0.5, color: '#FFFFFF' }} />
                                <Box sx={{ color: '#FFFFFF' }}>
                                    <Typography variant="h6" sx={{ color: '#FFFFFF' }}>Instagram</Typography>
                                    <Typography variant="body2" sx={{ cursor: 'pointer', color: '#FFFFFF', '&:hover': { textDecoration: 'underline' } }} onClick={() => externalNavigate('https://www.instagram.com/ecvconstructioninc/')}>
                                        @ecvconstructioninc
                                    </Typography>
                                </Box>
                            </Box>
                            <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 2 }}>
                                <TikTokIcon sx={{ fontSize: 30, mt: 0.5, color: '#FFFFFF' }} />
                                <Box sx={{ color: '#FFFFFF' }}>
                                    <Typography variant="h6" sx={{ color: '#FFFFFF' }}>TikTok</Typography>
                                    <Typography variant="body2" sx={{ cursor: 'pointer', color: '#FFFFFF', '&:hover': { textDecoration: 'underline' } }} onClick={() => externalNavigate('https://www.tiktok.com/@ecvconstructioninc')}>
                                        @ecvconstructioninc
                                    </Typography>
                                </Box>
                            </Box>
                        </Stack>
                    </Grid>
                    <Grid id="contact-img" item xs={12} sm={12} md={5} lg={4} sx={{ textAlign: { xs: 'left', md: 'left', }, display: 'flex', alignItems: 'center', justifyContent: 'center' }} >
                        <Box sx={{ width: '100%', height: '100%' }}>
                            <img src={contactImage} alt="Custom furniture" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                        </Box>
                    </Grid>
                </Grid>
                </Box>

                {/* Section: About and process */}
                <Box sx={{ p: 0, mt: { xs: 15, sm: 15, md: 20, lg: 30 }, backgroundImage: `url(${vanImage})`, backgroundSize: 'cover', backgroundPosition: '-400px center' }} >
                <Grid container rowSpacing={6} spacing={2} columns={12}>
                    <Grid id="about-process" item xs={12} sm={12} md={6} lg={6} xl={4} mdOffset={6} lgOffset={6} xlOffset={8} sx={{ textAlign: 'left', display: 'flex', flexDirection: 'column', justifyContent: 'center' }} >
                        <Card elevation={0} sx={{ height: '100%', maxWidth: '100%', p: 2, color: '', backgroundColor:'secondary.main', borderLeft: '2px solid', borderColor: 'primary.main' }}>
                            <CardContent>
                                
                                <Typography gutterBottom variant="h5" component="div">
                                    Who We Are
                                </Typography>
                                <Typography variant="body2">
                                    We love to create. We build from scratch so everything "just fits" and we are proud of the work we do.
                                    As a father-son team, we have grown our business throughout the Tampa Bay Area, building custom
                                    solutions for homes and commercial real estate. Our portfolio is growing and we would love to have
                                    the opportunity to work with you.
                                </Typography>
                                <Box sx={{ my: 3, borderTop: '1px solid', borderColor: 'white' }} />
                                <Typography gutterBottom variant="h5" component="div">
                                    Our Process
                                </Typography>
                                <ProjectTimeline></ProjectTimeline>
                                <ProjectTimelineMobile></ProjectTimelineMobile>
                            </CardContent>
                        </Card>
                    </Grid>
                </Grid>
                </Box>

                {/* Section: Association logos */}
                <Box sx={{  my: { xs: 10, sm: 10, md: 15, lg: 15 }, textAlign: 'center' }}>
                    <Grid container  spacing={2} columns={12} justifyContent="space-evenly" alignItems="center">
                        {orgLogos.map((logo, index) => 
                        <Grid item xs={4} md={2} key={index} >
                            <img src={logo} style={{ width: '100%' }} alt=""></img>
                        </Grid>
                    )}
                    </Grid>
                </Box>
            </Box>
        </Box>

    )
}